import React from 'react';
import styles from './FullLogoWhiteIcon.module.scss';

// Types
interface IProps {
	className?: string;
}

export const FullLogoWhiteIcon: React.FC<IProps> = ({ className }) => {
	return (
		<figure className={styles['logo']}>
			<svg
				className={className}
				xmlns='http://www.w3.org/2000/svg'
				width='88'
				height='21'
				viewBox='0 0 88 21'
				fill='none'
			>
				<path
					d='M11.2786 2.0472C12.8794 0.296767 15.4747 0.296767 17.0754 2.0472L27.1506 13.0648C28.7514 14.8152 28.7514 17.6533 27.1506 19.4037C25.55 21.1542 22.9547 21.1542 21.3539 19.4037L11.2786 8.38609C9.67796 6.63567 9.67796 3.79764 11.2786 2.0472Z'
					fill='#38A58F'
				/>
				<g opacity='0.43'>
					<path
						d='M15.193 12.6666L11.2792 8.38669C10.5685 7.60952 10.1734 6.61796 10.0938 5.60238L12.5018 2.96907C13.7381 1.61714 15.5676 1.30942 17.0739 2.04566C17.0745 2.04637 17.0752 2.04708 17.0759 2.0478L24.8508 10.5499C22.0799 8.82885 18.5136 9.20951 16.0945 11.6919H16.0843L15.193 12.6666Z'
						fill='#4C9E8D'
					/>
				</g>
				<path
					d='M14.8679 10.7544C17.6639 7.8852 21.9927 7.82376 24.8543 10.5701L17.0732 2.03294C15.4727 0.281218 12.8764 0.280609 11.2752 2.03157L1.20008 13.0491C-0.400028 14.7988 -0.400028 17.6357 1.20008 19.3854C2.701 21.0267 5.07642 21.1283 6.68561 19.6909L14.8578 10.7544H14.8679Z'
					fill='url(#paint0_linear_17556_19706)'
				/>
				<path
					d='M42.4723 19.8354C41.7654 19.8354 41.198 19.6271 40.7702 19.2105C40.3609 18.775 40.1562 18.1974 40.1562 17.4779V2.50938C40.3609 2.47151 40.6492 2.42417 41.0213 2.36736C41.412 2.31056 41.7933 2.28215 42.1654 2.28215C43.0025 2.28215 43.6071 2.42417 43.9792 2.7082C44.3512 2.99224 44.5373 3.55083 44.5373 4.38399V16.2282H51.2344C51.346 16.4175 51.4483 16.6637 51.5413 16.9666C51.6529 17.2696 51.7088 17.601 51.7088 17.9607C51.7088 18.5856 51.5692 19.059 51.2902 19.3809C51.0297 19.6839 50.667 19.8354 50.2019 19.8354H42.4723Z'
					fill='white'
				/>
				<path
					d='M60.1775 19.7501C59.9915 19.8069 59.731 19.8543 59.3962 19.8922C59.0613 19.949 58.6892 19.9774 58.28 19.9774C57.4428 19.9774 56.8382 19.8448 56.4662 19.5797C56.1127 19.2957 55.936 18.756 55.936 17.9607V6.41912C56.122 6.36232 56.3825 6.30551 56.7173 6.2487C57.0522 6.1919 57.4242 6.1635 57.8335 6.1635C58.6706 6.1635 59.2659 6.30551 59.6194 6.58954C59.9915 6.87358 60.1775 7.41324 60.1775 8.20853V19.7501ZM55.6849 2.32906C55.6849 1.68526 55.8988 1.13613 56.3267 0.681676C56.7731 0.227225 57.3498 0 58.0567 0C58.7637 0 59.3311 0.227225 59.7589 0.681676C60.2054 1.13613 60.4286 1.68526 60.4286 2.32906C60.4286 2.9918 60.2054 3.5504 59.7589 4.00485C59.3311 4.4593 58.7637 4.68653 58.0567 4.68653C57.3498 4.68653 56.7731 4.4593 56.3267 4.00485C55.8988 3.5504 55.6849 2.9918 55.6849 2.32906Z'
					fill='white'
				/>
				<path
					d='M69.577 8.8293H74.3207C74.4137 9.01865 74.5068 9.25535 74.5998 9.53938C74.7114 9.82341 74.7672 10.1359 74.7672 10.4767C74.7672 11.0826 74.6277 11.5182 74.3486 11.7832C74.0882 12.0483 73.744 12.1809 73.3162 12.1809H69.7723V19.7501C69.5863 19.8069 69.3258 19.8543 68.991 19.8922C68.6561 19.949 68.284 19.9774 67.8748 19.9774C67.0376 19.9774 66.433 19.8448 66.061 19.5797C65.6889 19.2957 65.5029 18.756 65.5029 17.9607V7.60796C65.5029 6.68012 65.6517 5.87536 65.9494 5.19369C66.2656 4.51201 66.6935 3.96288 67.233 3.5463C67.7725 3.11079 68.405 2.78888 69.1305 2.58059C69.856 2.3723 70.6373 2.26815 71.4745 2.26815C72.7953 2.26815 73.7719 2.44804 74.4044 2.80781C75.0556 3.14865 75.3811 3.71672 75.3811 4.51201C75.3811 4.87178 75.3067 5.19368 75.1579 5.47772C75.0276 5.74281 74.8695 5.9511 74.6835 6.10258C74.33 5.98897 73.9487 5.89429 73.5394 5.81855C73.1487 5.74281 72.7023 5.70494 72.2 5.70494C71.3442 5.70494 70.6931 5.86589 70.2467 6.1878C69.8002 6.49076 69.577 7.01149 69.577 7.74997V8.8293Z'
					fill='white'
				/>
				<path
					d='M83.7315 15.0578C83.7315 15.588 83.8989 15.9762 84.2338 16.2224C84.5686 16.4496 85.0337 16.5632 85.629 16.5632C85.9081 16.5632 86.2057 16.5348 86.522 16.478C86.8382 16.4023 87.108 16.3171 87.3312 16.2224C87.4986 16.4117 87.6381 16.6295 87.7498 16.8757C87.8614 17.1218 87.9172 17.4058 87.9172 17.7277C87.9172 18.3905 87.6568 18.9396 87.1359 19.3751C86.6336 19.7917 85.7499 20 84.4849 20C82.9223 20 81.7038 19.6402 80.8294 18.9207C79.9551 18.1822 79.5179 16.9893 79.5179 15.3419V2.58882C79.7225 2.53201 79.9923 2.47521 80.3271 2.4184C80.662 2.34266 81.0248 2.30479 81.4154 2.30479C82.234 2.30479 82.82 2.45627 83.1734 2.75924C83.5455 3.04327 83.7315 3.57347 83.7315 4.34982V8.81484H87.5823C87.6754 9.00419 87.7684 9.25036 87.8614 9.55332C87.9544 9.83736 88.0009 10.1403 88.0009 10.4622C88.0009 11.0682 87.8614 11.5037 87.5823 11.7688C87.3219 12.0339 86.9777 12.1664 86.5499 12.1664H83.7315V15.0578Z'
					fill='white'
				/>
				<defs>
					<linearGradient
						id='paint0_linear_17556_19706'
						x1='16.876'
						y1='2.87075'
						x2='-1.29797'
						y2='17.6237'
						gradientUnits='userSpaceOnUse'
					>
						<stop stopColor='#9AFFD6' />
						<stop offset='0.15625' stopColor='#7EE5BE' />
						<stop offset='1' stopColor='#58B2A4' />
					</linearGradient>
				</defs>
			</svg>
		</figure>
	);
};
